import Chart from 'chart.js';
import axios from 'axios';
import numeral from 'numeral';
import { customTooltips } from './utils';

const createChartData = raw => ([
    {
        label: raw.legend.bar,
        type: 'bar',
        data: raw.datasets.bar,

        borderWidth: 0,
        borderColor: 'rgba(255,255,255, 0.75)',
        backgroundColor: 'rgba(255,255,255, 0.75)',
        hoverBackgroundColor: 'rgba(255,255,255, 0.75)',
    },
    {
        label: raw.legend.line,
        type: 'shadowLine',
        data: raw.datasets.line,
        fill: false,

        borderWidth: 10,
        borderColor: 'rgb(253,240,97)',
        backgroundColor: 'rgb(253,240,97)',

        pointRadius: 4,
        pointBorderWidth: 0,
        pointBackgroundColor: 'rgb(253,240,97)',
    },
]);

const config = {
    responsive: true,
    legend: {
        display: false,
    },
    legendCallback(chart) {
        return chart.data.datasets.map(dataset => (
            `<li class="line-bar-chart__legend-item-${dataset.label}">
                <span style="background-color:${dataset.backgroundColor}"></span>
                ${dataset.label}
            </li>`
        )).join('');
    },
    tooltips: {
        enabled: false,
        custom(tooltip) {
            if (tooltip.body === undefined) {
                customTooltips({
                    tooltip,
                    chart: this,
                    hide: true,
                });
                return;
            }

            tooltip.body.map((bodyItem, index) => {
                const label = bodyItem.lines[0].split(': ');

                customTooltips({
                    tooltip,
                    chart: this,
                    value: label[1],
                    text: label[0],
                    colour: tooltip.labelColors[index].borderColor,
                    hide: false,
                });
                return true;
            });
        },
    },
    scales: {
        xAxes: [{
            barThickness: 40,
            position: 'bottom',
            gridLines: {
                display: false,
                drawBorder: false,
            },
            ticks: {
                beginAtZero: true,
                fontFamily: 'Gotham, Helvetica, sans-serif',
                fontSize: 13,
                fontStyle: 500,
                fontColor: 'rgba(255,255,255, 0.75)',
            },
        }],
        yAxes: [{
            position: 'right',
            gridLines: {
                color: 'rgba(255,255,255, 0.25)',
                zeroLineColor: 'rgba(255,255,255, 0.25)',
                zeroLineWidth: 1,
                drawBorder: false,
            },
            ticks: {
                beginAtZero: true,
                fontFamily: 'Gotham, Helvetica, sans-serif',
                fontSize: 13,
                fontStyle: 500,
                fontColor: 'rgba(255,255,255, 0.75)',
                callback(label) {
                    return numeral(label).format('0.[00]a');
                },
            },
        }],
    },
    cornerRadius: 500,
    animation: {
        onComplete() {
            this.canvas.nextElementSibling.setAttribute('src', this.toBase64Image());
        },
    },
};

export default (() => {
    const charts = Array.from(document.querySelectorAll('.js-line-bar-chart'));

    charts.forEach((canvas) => {
        const ctx = canvas.getContext('2d');
        const chart = new Chart(ctx, { type: 'bar', options: config });
        const legend = canvas.closest('.line-bar-chart').querySelector('.js-line-bar-legend');

        axios.get(`/api/chart/line-bar/${canvas.dataset.chart}.json`)
            .then(response => ({ response, data: createChartData(response.data) }))
            .then(({ response, data }) => {
                chart.data.datasets = data;
                chart.data.labels = response.data.labels;
                chart.update();
                legend.innerHTML = chart.generateLegend();
            });
    });
})();
